import React, { useState } from 'react'
import styled from 'styled-components'
import Checkbox from 'rc-checkbox'
import 'rc-checkbox/assets/index.css'
import { isMobile } from 'react-device-detect'
import GenericRow from './GenericRow'

import GenericTextSpan from './GenericTextSpan'

const CheckboxBox = styled.div`
  width: ${(props) =>
    props.containerStyle.width ? props.containerStyle.width : '100%'};
  display: ${(props) =>
    props.containerStyle.display ? props.containerStyle.display : 'flex'};
  position: ${(props) =>
    props.containerStyle.position ? props.containerStyle.position : 'relative'};
  justify-content: ${(props) =>
    props.containerStyle.justify ? props.containerStyle.justify : 'center'};
  align-items: ${(props) =>
    props.containerStyle.align ? props.containerStyle.align : 'center'};
  margin: ${(props) =>
    props.containerStyle.margin ? props.containerStyle.margin : 'unset'};
  flex-direction: ${(props) =>
    props.containerStyle.fDir ? props.containerStyle.fDir : 'row'};

  label {
    width: ${(props) =>
      props.containerStyle.width ? props.containerStyle.width : '100%'};
    display: ${(props) =>
      props.containerStyle.display ? props.containerStyle.display : 'flex'};
    position: ${(props) =>
      props.containerStyle.position
        ? props.containerStyle.position
        : 'relative'};
    justify-content: ${(props) =>
      props.containerStyle.justify ? props.containerStyle.justify : 'center'};
    align-items: ${(props) =>
      props.containerStyle.align ? props.containerStyle.align : 'center'};
    margin: ${(props) =>
      props.containerStyle.margin ? props.containerStyle.margin : 'unset'};
    flex-direction: ${(props) =>
      props.containerStyle.fDir ? props.containerStyle.fDir : 'row'};

    span {
      text-align: left;
    }
  }

  .rc-checkbox {
    &.rc-checkbox-checked {
      .rc-checkbox-inner {
        border-color: #a1ff68;
        background-color: #a1ff68;

        width: ${(props) =>
          props.checkboxStyle.width ? props.checkboxStyle.width : '14px'};
        height: ${(props) =>
          props.checkboxStyle.height ? props.checkboxStyle.height : '14px'};

        &:after {
          border: ${(props) =>
            props.checkboxStyle.width ? `2px solid black` : '2px solid black'};
          left: ${(props) => (props.checkboxStyle.width ? `6px` : '4px')};
          top: ${(props) => (props.checkboxStyle.width ? `3px` : '1px')};
          border-top: 0;
          border-left: 0;
        }
      }
    }

    .rc-checkbox-inner {
      background-color: ${(props) =>
        props.checkboxStyle.backgroundColor
          ? props.checkboxStyle.backgroundColor
          : 'transparent'};
      border-color: ${(props) =>
        props.checkboxStyle.backgroundColor
          ? props.checkboxStyle.backgroundColor
          : 'white'};

      width: ${(props) =>
        props.checkboxStyle.width ? props.checkboxStyle.width : '14px'};
      height: ${(props) =>
        props.checkboxStyle.height ? props.checkboxStyle.height : '14px'};

      &:after {
        border: 2px solid transparent;
      }
    }
  }
`

const CheckboxLabel = styled.label`
  color: white;
  font-family: 'Nunito';
  width: 100%;

  a {
    color: #a1ff68;
    margin: 0 4px;
  }
`

const GenericCheckbox = ({
  isCheckboxChecked,
  checkCheckbox,
  text,
  containerStyle,
  checkboxStyle,
  defaultChecked,
  name,
  textMargin,
  textSize,
  regulations,
}) => {
  return (
    <CheckboxBox checkboxStyle={checkboxStyle} containerStyle={containerStyle}>
      <CheckboxLabel>
        <Checkbox
          onChange={(e) => checkCheckbox(e)}
          name={name}
          defaultChecked={defaultChecked}
          checked={isCheckboxChecked}
        />
        {!regulations ? (
          <GenericTextSpan
            fSize={textSize}
            margin={isMobile ? '0 10px' : '5px 10px'}
          >
            {text}
          </GenericTextSpan>
        ) : (
          <GenericTextSpan margin={'0 0 0 3%'} tAlign={'left'}>
            Zapoznałam się i zaakceptowałam
            <a
              href="https://fitmatkawariatka.pl/regulamin-aplikacji-od-03-01-2022-r/"
              target="_blank"
              rel="nofollow noopener noreferrer"
            >
              {' '}
              Regulamin{' '}
            </a>{' '}
            oraz
            <a
              rel="nofollow noopener noreferrer"
              target="_blank"
              href="https://fitmatkawariatka.pl/polityka-prywatnosci-aplikacja-miazga/"
            >
              {' '}
              Politykę prywatności
            </a>
          </GenericTextSpan>
        )}
      </CheckboxLabel>
    </CheckboxBox>
  )
}

export default GenericCheckbox
